function authHeaders(json) {
  const headers = {
    Authorization: `Bearer ${localStorage.getItem('jwt_token') || ''}`
  }
  if (json) headers['Content-Type'] = 'application/json'
  return headers
}

async function readJson(res) {
  const data = await res.json().catch(() => ({}))
  if (data.code !== 200) {
    throw new Error(data.message || '请求失败')
  }
  return data
}

export async function listCourseOss({ page = 1, pageSize = 20, keyword = '', kcId = 0 } = {}) {
  const res = await fetch('/api/v1/knowledge/media/oss/list', {
    method: 'POST',
    headers: authHeaders(true),
    body: JSON.stringify({ page, pageSize, keyword, kcId: Number(kcId) || 0 })
  })
  return readJson(res)
}

export async function updateCourseOss({ id, title, kcId }) {
  const res = await fetch('/api/v1/knowledge/media/oss/update', {
    method: 'POST',
    headers: authHeaders(true),
    body: JSON.stringify({ id, title, kcId: Number(kcId) || 0 })
  })
  return readJson(res)
}

export async function deleteCourseOss(id) {
  const res = await fetch('/api/v1/knowledge/media/oss/delete', {
    method: 'POST',
    headers: authHeaders(true),
    body: JSON.stringify({ id })
  })
  return readJson(res)
}

export async function uploadCourseOss({ file, title, encrypt, kcId, mediaType }) {
  const fd = new FormData()
  fd.append('file', file)
  if (title) fd.append('title', title)
  fd.append('encrypt', encrypt ? '1' : '0')
  if (kcId) fd.append('kcId', String(kcId))
  if (mediaType) fd.append('mediaType', mediaType)
  const res = await fetch('/api/v1/knowledge/media/oss/upload', {
    method: 'POST',
    headers: authHeaders(false),
    body: fd
  })
  return readJson(res)
}
